<template>
  <v-expand-transition>
    <v-sheet dark v-if="status">
      <v-container class="pb-10">
        
        <p class="text-right my-0">
          <v-btn
            class="mx-2 f"
            icon
            @click="hide"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </p>

        <v-slide-group show-arrows>
          <v-slide-item
            v-for="item in menu"
            :key="item.id">
            
            <v-card width="120" 
                    :elevation="0"
                    class="px-5">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-img :src="item.image" 
                         contain 
                         v-bind="attrs"
                         v-on="on"
                         @click="open(item)"
                         :style="{ opacity:item.disabled ? 0.7:1 }" />
                </template>
                <span>{{ item.label }}</span>
              </v-tooltip>
            </v-card>

          </v-slide-item>
        </v-slide-group>

      </v-container>
    </v-sheet>
  </v-expand-transition>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'

   export default {
    
    name: 'AppMenu',

    mixins: [],

    components:
    {

    },

    data: () => ({
      
    }),

    computed:
    {
      ...mapGetters({
        menu: 'menu/apps',
        status: 'menu/appMenuStatus'
      })
    },

    methods:
    {
      ...mapActions({
        openApp: 'menu/open',
        showAppMenu: 'menu/showAppMenu'
      }),

      ...mapMutations({
        setLoading: 'ui/setLoading'
      }),

      hide()
      {
        this.showAppMenu(false)
      },

      open(item)
      {
        if( item.disabled )
          return

        if( !item.isOpen )
          this.setLoading('linear')

        this.openApp(item)

        this.hide()
      }
    },

    load(){}
  }
</script>